module.exports = __webpack_public_path__ + "static/media/heartipro-carrying-case-2.f868585d.png";